import { render, staticRenderFns } from "./ProjectQuests.vue?vue&type=template&id=53a4496d&scoped=true&"
import script from "./ProjectQuests.vue?vue&type=script&lang=js&"
export * from "./ProjectQuests.vue?vue&type=script&lang=js&"
import style0 from "./ProjectQuests.vue?vue&type=style&index=0&id=53a4496d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4496d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
